import React, {forwardRef, useEffect, useRef} from 'react';
import {generateColumnClass} from "../../Utility";
import Icon from "../../ui/Icon";

const SearchInput = forwardRef(({
                                    name,
                                    value,
                                    error,
                                    label,
                                    onChange,
                                    onBlur,
                                    columns,
                                    placeholder,
                                    inline,
                                    isSearchStyle = false,
                                    focusOnRender = true
                                }, ref) => {

    const innerRef = useRef(null);
    const inputRef = ref || innerRef;

    useEffect(() => {
        if (focusOnRender && inputRef.current) {
            inputRef.current.focus();
        }
    }, [focusOnRender, inputRef]);

    const columnClass = generateColumnClass(columns);
    const className = `${inline ? 'd-flex flex-wrap ' : ''}col-12${columnClass}`;
    const multiInputStyle = {
        border: 'none',
        boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px'
    };

    return (
        <div className={className}>
            {label &&
                <label className={`form-label opacity-75${inline ? ' mb-0 py-2 col-12 col-md-4' : ''}`}
                       htmlFor={name}>
                    {label}
                </label>
            }
            <div className="position-relative">
                <Icon name="search" width="24" height="24" fill="secondary" className="position-absolute h-100 ms-2"/>
                <input type="text"
                       ref={inputRef}
                       className={`form-control fs-md ps-6${inline ? ' col' : ''}`}
                       style={isSearchStyle ? multiInputStyle : {}}
                       name={name}
                       value={value}
                       placeholder={placeholder}
                       onChange={onChange}
                       onBlur={onBlur}
                       id={name}
                />
            </div>
            {error && <div
                className={`form-text text-start text-danger w-100${inline && label ? ' offset-md-4' : ''}`}>{error}</div>}
        </div>
    )
})

export default SearchInput;

